import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import VideoCard from "../../common/VideoCard";
import useSelectVideo from "../../../hooks/useSelectVideo";
import SkeletonVideoCard from "../../skeleton/SkeletonVideoCard";
import { useLocation } from "react-router-dom";

export function LikedTab({ User_likedVideos, loading, nextPage }) {
    const selectVideo = useSelectVideo();
    const [LikedVideos, setLikedVideos] = useState([]);
    const location = useLocation();


    // const handleSelectVideo = async (id) => {
    //     selectVideo(id, LikedVideos, location.pathname);
    // };
    const handleSelectVideo = async (id) => {
        selectVideo(id, LikedVideos, location.pathname, 'liked', nextPage);
    };

    useEffect(() => {
        setLikedVideos(User_likedVideos);
    }, [User_likedVideos]);


    return (
        <>
            {loading ? (
                <SkeletonVideoCard />
            ) : (
                <>
                    <div className="grid grid-cols-3 p-2 gap-1 overflow-y-scroll">
                        {LikedVideos?.map((item) => (
                            <VideoCard
                                id={item.id}
                                belowDecs={true}
                                body={item.post_description}
                                threeDots={false}
                                video={item.video_url}
                                user_id={item.created_by.id}
                                authorId={item.created_by.id}
                                view_count={item.view_count}
                                likes_count={item.likes_count}
                                selectVideo={handleSelectVideo}
                                avatar_url={item.created_by.avatar_url}
                                thumbnail={item.thumbnail_url}
                            />
                        ))}
                    </div>
                </>
            )}

            {LikedVideos?.length === 0 && !loading && (
                <div className="flex justify-center items-center">
                    <p className="text-[12px] mt-20 text-gray-600 dark:text-gray-500">
                        Posts you like will appear here.
                    </p>
                </div>
            )}
        </>
    );
}
